import React, { useEffect, useState, useRef } from 'react'
import smartoptLogo from "../assets/images/smartoptLogo.png"
import { useTabbarButtonsNavList } from '../Constants/Constants'
import TabbarNavButton from './TabbarNavButton'
import { Button, Dropdown } from 'antd';
import BreakdownModal from './ModalComponent/BreakdownModal';
import { NavLink } from 'react-router-dom';
import { Select, Option } from "@material-tailwind/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSolid, faUser } from '@fortawesome/free-solid-svg-icons';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';

export default function Tabbar() {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language?.substring(0, 2) || "en";
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const langDropdownRef = useRef(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false)
  const appDropdown = useRef(null);
  const { user, logout } = useAuth0();
  const tabbarButtonsNavList = useTabbarButtonsNavList();

  // Dil seçenekleri
  const languages = [
    { code: "en", name: "English", flag: "EN" },
    { code: "tr", name: "Türkçe", flag: "TR" },
  ];

  // Mevcut dil nesnesini bul
  const currentLangObj =
    languages.find((lang) => lang.code === currentLanguage) || languages[0];

  // Dil değiştirme fonksiyonu
  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem("language", langCode);
    setIsLangDropdownOpen(false);
  };

  useEffect(() => {
    //* for close menu
    const closeOpenMenus = (e) => {
      if (appDropdown.current && openDropdown && !appDropdown.current.contains(e.target)) {
        setOpenDropdown(false)
      }
      if (langDropdownRef.current && isLangDropdownOpen && !langDropdownRef.current.contains(e.target)) {
        setIsLangDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', closeOpenMenus)
    return () => {
      document.removeEventListener('mousedown', closeOpenMenus)
    }
  }, [openDropdown, isLangDropdownOpen])

  const items = [
    {
      key: '1',
      label: (
        <p>
          {user.name}
        </p>
      ),
    },
    {
      key: '2',
      label: (
        // 68. satırı şu şekilde değiştirin:
        <a onClick={() => logout({ logoutParams: { returnTo: 'https://acool2metal.bshsmartplanning.smartopt.com.tr/' } })}>
          {t('navbar.logout')}
        </a>
      ),
    },
  ];

  return (
    <>
      <BreakdownModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />

      <div className='bg-gray-500 w-full flex-row flex h-15 p-3 gap-10 pr-10 items-center'>
        <img src={smartoptLogo} alt="SiyahLogo" width={120} height={20} />
        <div className='flex flex-row gap-5 w-full'>
          <div className='relative lg:hidden  flex items-center'>
            <button className='	hover:bg-gray-300 text-white border p-2 rounded transition-all duration-200 font-bold' onClick={() => setOpenDropdown(!openDropdown)}>{t('navbar.menu')}</button>
            <div onClick={() => setOpenDropdown(false)} ref={appDropdown} className={`${openDropdown ? "flex" : "hidden"} flex-col z-50 w-40 right-10 left-1 absolute top-12  gap-2 bg-gray-500  rounded-md p-2 border-2 shadow-sm`}>
              {
                tabbarButtonsNavList.map((item, index) =>
                  <TabbarNavButton key={index} name={item.name} url={item.url} />)
              }
            </div>
          </div>
          <div className='lg:flex flex-row border rounded gap-5 hidden'>
            {
              tabbarButtonsNavList.map((item, index) =>
                <TabbarNavButton key={index} name={item.name} url={item.url} />)
            }
          </div>
          <button
            onClick={() => setModalOpen(true)}
            className='whitespace-nowrap text-white	hover:bg-gray-300 hover:text-gray-900 p-2 rounded transition-all duration-200 font-bold'
          >
            {t('navbar.breakdown')}
          </button>

          <NavLink
            to="/support"
            style={({ isActive }) => ({
              color: isActive ? '#fff' : null,
              background: isActive ? '#f1b634' : null,
            })}
            className='whitespace-nowrap text-white	hover:bg-gray-300 hover:text-gray-900 p-2 rounded transition-all duration-200 font-bold'
          >
            {t('navbar.support')}
          </NavLink>
        </div>

        <div className="ml-auto flex flex-row items-center gap-2">
          <div ref={langDropdownRef} className="relative mr-2">
            <button
              onClick={() => setIsLangDropdownOpen((v) => !v)}
              className="flex items-center gap-1 text-white hover:text-gray-900 transition-colors px-2 py-1 rounded-md hover:bg-gray-300"
              aria-label={t('navbar.language')}
            >
              <span className="text-xs mt-0.5">
                {currentLangObj.code.toUpperCase()}
              </span>
              <svg
                className={`w-3 h-3 ml-1 transition-transform ${isLangDropdownOpen ? "rotate-180" : ""}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {isLangDropdownOpen && (
              <div className="absolute right-0 mt-1 w-36 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                <div className="py-1">
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      className={`
                        ${currentLanguage === lang.code ? "bg-gray-200 text-gray-900" : "text-gray-700 hover:bg-gray-100"}
                        flex items-center w-full px-4 py-2 text-sm text-left transition-colors
                      `}
                      onClick={() => changeLanguage(lang.code)}
                    >
                      <span className="mr-2">{lang.flag}</span>
                      {lang.name}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
          <Dropdown
            menu={{
              items,
            }}
            placement="bottomRight"
            arrow={{
              pointAtCenter: true,
            }}
            trigger={['click']}
          >
            <Button className='border-0 hover:border-0'>
              <FontAwesomeIcon icon={faUser} size="xl" style={{ color: "#f1b634", }} />
            </Button>
          </Dropdown>
        </div>
      </div>
    </>
  )
}
